import styles from "./connectedgateways.module.css";

const GatewaySignal = ({ val }) => {
    if (parseInt(val) >= -60)
        return (<p className={`${styles.SIgnal} ${styles.Good}`}>Strong <img src="/static/img/signal-verygood.svg" alt="" /></p>);
    if (parseInt(val) > -75)
        return (<p className={`${styles.SIgnal} ${styles.Good}`}>Strong <img src="/static/img/signal-goodD.svg" alt="" /></p>);
    if (parseInt(val) > -85)
        return (<p className={`${styles.SIgnal} ${styles.Medium}`}>Medium <img src="/static/img/signal-mediumD.svg" alt="" /></p>);
    return (<p className={`${styles.SIgnal} ${styles.Weak}`}>Weak <img src="/static/img/signal-weakD.svg" alt="" /></p>)
}

const ConnectedGateways = ({ gateways }) => {
    return (<div className={`${styles.GateWayListRow}`}>
        {gateways?.length > 0 && <>
            {gateways?.map((item, index) => {
                return (<div className={`${styles.GateWayList}`}>
                    <p className={`${styles.Title}`}>#{index + 1}: {item?.gateway_name}</p>
                    <GatewaySignal val={item?.rssi} />
                </div>)
            })}
        </>}

        {gateways?.length === 0 && <div className={`${styles.NoDataMain}`}>
            <div className={`${styles.NoDataIMG}`}>
                <img src="/static/img/router-black.svg" alt="No Data" />
            </div>
            <p className={`${styles.NoDataText}`}>Sorry!</p>
            <p className={`${styles.NoDataTextSub}`}>No Gateway is Connected Now.</p>
        </div>}
    </div>);
}


export default ConnectedGateways;